import { render, staticRenderFns } from "./ReviewCategories.vue?vue&type=template&id=d39d5a66&"
import script from "./ReviewCategories.vue?vue&type=script&lang=js&"
export * from "./ReviewCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports